import { Component, inject } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { DeleteAccountFormModel } from "../../models/delete-account-form.model";
import { TextInputComponent } from "@app/kernel/form/modules/inputs/simple-inputs/components/text-input/text-input.component";

@Component({
  selector: "app-delete-account-form",
  standalone: true,
  imports: [ReactiveFormsModule, TextInputComponent, TranslateModule, CommonModule],
  templateUrl: "./delete-aacount-form.component.html",
  styleUrls: ["./delete-aacount-form.component.scss"],
})
export class DeleteAccountFormComponent {
  readonly formModel = inject(DeleteAccountFormModel);
}
